module.exports = __webpack_public_path__ + "img/sliders.24da65bd.svg";